import Type3 from "./option";

export default Type3;
